/**
 * Mask customer link tokens in URLs before they reach logs or telemetry.
 *
 * Portal, proposal-accept, MSA review and intake links carry a bearer token in
 * the URL path. Anyone holding the token can act as the customer, so a copy in
 * server logs, App Insights or Sentry is a usable credential. This is the one
 * shared rule; the backend logger, the backend Sentry scrubber, the OTel span
 * processor and the CRM/intake browser Sentry hooks all call it. (The portal
 * app keeps its own RIG-299 scrubber.)
 *
 * Shapes covered:
 *   - API:  /api/v1/.../by-token/<token>/...
 *   - SPA:  /portal/<token>, /msa/<token>, /intake/<token>,
 *           /proposal/<token>, /proposal/accept/<token>, /proposal/accepted/<token>
 * The token runs to the next `/`, `?`, `#` or whitespace.
 */
export const TOKEN_PLACEHOLDER = '[token-redacted]';
export function scrubTokenUrls(input) {
    return input
        .replace(/\/by-token\/[^/?#\s]+/g, `/by-token/${TOKEN_PLACEHOLDER}`)
        .replace(/\/proposal\/(accept|accepted)\/(?!by-token(?:[/?#\s]|$))[^/?#\s]+/g, `/proposal/$1/${TOKEN_PLACEHOLDER}`)
        .replace(/\/(portal|msa|intake|proposal)\/(?!by-token(?:[/?#\s]|$)|accept(?:ed)?(?:[/?#\s]|$)|\[token-redacted\])[^/?#\s]+/g, `/$1/${TOKEN_PLACEHOLDER}`);
}
/**
 * Walk a JSON-ish value (a Sentry event, breadcrumb or span attributes) and
 * mask tokens in every string. Mutates objects and arrays in place and returns
 * the value, matching Sentry's before* hook contract.
 */
export function scrubTokensDeep(value, depth = 0) {
    if (depth > 12)
        return value;
    if (typeof value === 'string')
        return scrubTokenUrls(value);
    if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++)
            value[i] = scrubTokensDeep(value[i], depth + 1);
        return value;
    }
    if (value !== null && typeof value === 'object') {
        const rec = value;
        for (const k of Object.keys(rec))
            rec[k] = scrubTokensDeep(rec[k], depth + 1);
    }
    return value;
}
//# sourceMappingURL=token-scrub.js.map